import { useEffect, useState } from "react";
import {
  IonContent,
  IonPage,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  useIonModal,
  useIonToast,
  IonProgressBar,
  isPlatform,
} from "@ionic/react";
import {
  callOutline,
  chevronBackOutline,
  eye,
  linkOutline,
  reloadCircleOutline,
  reloadOutline,
  shareOutline,
  videocam,
  warning,
} from "ionicons/icons";
import {
  getAdvertisementFilesFunction,
} from "../../services/API";
import "./nhcAdvertisement.styles.css";
import { useSelector } from "react-redux";
import propertyServicesSvg from "../../images/propertyServices.svg";
import propertyAgeSvg from "../../images/propertyAge.svg";
import propertyTypeSvg from "../../images/propertyType.svg";
import guestRoomSvg from "../../images/guestRoom.svg";
import buildingMeasurementSvg from "../../images/buildingMeasurement.svg";
import Button from "../../components/atoms/button";
import { OverlayEventDetail } from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import Spinner from "../../components/atoms/spinner";
import QRCode from "react-qr-code";
import LightGalleryComponent, { MediaItem } from "../../components/molecules/LightGalleryComponent";
import { addWatermarkToImage } from "./waterMark";
import { getVideoThumbnail } from "./videoToThumbnail";
import { Clipboard } from "@capacitor/clipboard";
import { presentToastFunction } from "../../services/genericMethoud/generice";
import { NumberWithCommas } from "../../configs/GenericFunc";
import SarIcon from "../../components/atoms/icons/sar-icon";
import { NhcAdvertisementProps, IAdvertisementData, IFileItem, ModalImagesProps, ModalVideoProps } from "./nhcAdvertisement.dto";

const NOT_AVAILABLE = <span className="text-redColor">غير متوفر</span>;

const NhcAdvertisement = ({
  objectId,
  adLicenseNumber,
  advertisement,
  onDismissAdvertisement,
}: NhcAdvertisementProps) => {
  const [property, setProperty] = useState<IAdvertisementData>(advertisement);
  const [image, setImage] = useState<string>("");
  const [video, setVideo] = useState<string>("");
  const { token } = useSelector((state: any) => state.reducer);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [files, setFiles] = useState<IFileItem[]>([]);
  let [presentToast] = useIonToast();
  const [retryCount, setRetryCount] = useState(0);

  //model property.aNhcIntegrationResultDTO
  const [presentIamgeModal, onCloseImageDismiss] = useIonModal(
    ModalImagesExample,
    {
      image,
      onCloseImageDismiss: (data: string, role: string) =>
        onCloseImageDismiss(data, role),
    }
  );

  function openpImageModal() {
    presentIamgeModal({
      animated: true,
      breakpoints: [1, 1, 1, 0.5, 1],
      initialBreakpoint: 0.7,
      // backdropBreakpoint: 0.7,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }

  //model video property.aNhcIntegrationResultDTO
  const [presentVideoModal, onCloseVideoDismiss] = useIonModal(
    ModalVideoExample,
    {
      video,
      onCloseVideoDismiss: (data: string, role: string) =>
        onCloseVideoDismiss(data, role),
    }
  );

  function openpVideoModal() {
    presentVideoModal({
      animated: true,
      breakpoints: [1, 1, 1, 0.5, 1],
      initialBreakpoint: 0.7,
      // backdropBreakpoint: 0.7,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }

  async function fetchFiles(explicitReload = false) {
    if (retryCount >= 3 && explicitReload == false) {
      setFiles([]); // Clear files after max retries
      setIsLoadingFiles(false);
      return; // Stop further retries
    }

    setIsLoadingFiles(true);
    const newFiles = [];
    setFiles([]);

    try {
      for (const fileId of property.nhcIntegration.attachFiles) {
        const fileData = await getAdvertisementFilesFunction(fileId, objectId, token);
        if (!fileData.data || !fileData.data.file) {
          throw new Error(`Failed to load file with ID: ${fileId}`);
        }
        const file: IFileItem = {
          isImage: fileData.data.isImage,
          file: fileData.data.isImage
            ? await addWatermarkToImage(fileData.data.file)
            : fileData.data.file,
          thumbnail: fileData.data.isImage
            ? fileData.data.file
            : await getVideoThumbnail(fileData.data.file, 200),
        };
        newFiles.push(file);
      }
      setFiles(newFiles);
      console.log("newFiles", newFiles);
      if (explicitReload === true) {
        setRetryCount(0); // Reset retry count on success
      } else {
        setRetryCount(prev => prev + 1);
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      setRetryCount(prev => prev + 1); // Increment retry count on failure
    } finally {
      setIsLoadingFiles(false);
    }
  }

  useEffect(() => {
    setIsLoading(false); // Data is already loaded from parent
    console.log("Using advertisement data from parent:", advertisement);

    // Update the property state when advertisement prop changes
    if (advertisement) {
      setProperty(advertisement);
    }

    // Fetch files after a short delay to ensure component is mounted
    setTimeout(async () => {
      await fetchFiles();
    }, 500);
  }, [advertisement]);

  const [isExpanded, setIsExpanded] = useState({
    location: false,
    basicPropInformation: false,
    internPropDetails: false,
    propLegalStatus: false,
    propFinancialValue: false,
    AdvertiserInformation: false,
    location_DocInfo: false,
    AdvertisementDates_Licensing: false,
  });

  return (
    <IonPage>
      <IonContent>
        <div
          id="ii"
          className="w-full h-full relative flex flex-col justify-start items-center bg-white"
        >
          {isLoading ? <Spinner color={"primary"} size={"large"} /> : null}
          <div className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${isPlatform("ios") && "pt-7"}`}>
            <div className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"} px-6 flex flex-row justify-center items-center`}>
              {property.nhcIntegration.objectId &&
                property.nhcIntegration.objectId != 0 &&
                property.nhcIntegration.objectId != " " && (
                  <button
                    onClick={() => {
                      setIsLoading(true);
                      let longitude = property.aNhcIntegrationResultDTO.body.result.advertisement.location.longitude;
                      let latitude = property.aNhcIntegrationResultDTO.body.result.advertisement.location.latitude;
                      Clipboard.write({
                        string: `https://thki.sa/app/${longitude}/${latitude}`,
                      });
                      setIsLoading(false);
                      presentToastFunction(
                        presentToast,
                        "top",
                        "success",
                        `تم نسخ رابط الإعلان بنجاح`
                      );
                    }}
                    className="flex flex-col justify-center items-center"
                  >
                    <IonIcon
                      icon={shareOutline}
                      className="text-2xl text-white font-bold"
                    />
                  </button>
                )}
            </div>
            <div className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"} flex flex-row justify-center items-center`}>
              <p className="font-bold text-white text-2xl">تفاصيل الاعلان</p>
            </div>
            <div className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"} px-6 flex flex-row justify-end items-center`}>
              <button
                onClick={() => {
                  onDismissAdvertisement(null, "cancle");
                }}
                className="flex flex-col justify-center items-center"
              >
                <IonIcon
                  icon={chevronBackOutline}
                  className="text-2xl text-white"
                />
              </button>
            </div>
          </div>

          <div
            className={`col-span-1 w-full flex flex-row justify-start items-center mt-4 mr-4 ${!isLoading && "animate__animated animate__backInLeft"
              }`}
          >
            <p className=" text-primaryColor100 text-2xl">الملفات المرفقة :</p>
          </div>
          {isLoadingFiles && (
            <IonToolbar className="bg-transparent">
              <IonProgressBar
                type="indeterminate"
                className="bg-transparent"
              ></IonProgressBar>
            </IonToolbar>
          )}
          {property.nhcIntegration.attachFiles.length == 0 ? (
            <div
              className={`w-80 bg-bkColor rounded border-[1px] border-paragraphColor flex flex-row justify-center items-center py-4 mt-4 ${!isLoading && "animate__animated animate__backInLeft"
                }`}
            >
              <p className="font-medium text-paragraphColor text-sm">
                لا توجد ملفات على هذا العقار !
              </p>
            </div>
          ) : retryCount >= 3 ? (
            <>
              {!isLoading && !isLoadingFiles && (
                <h2 className="w-full mr-2 text-base text-redColor">
                  في حالة وجود مشكله في المرفقات الرجاء الضغط هنا:{" "}
                  <IonIcon
                    className="text-xl text-primaryColor100 cursor-pointer"
                    icon={reloadOutline}
                    onClick={async () => await fetchFiles(true)}
                  />
                </h2>
              )}
              <div
                className={`w-80 bg-red-500 text-white rounded border-[1px] border-white flex flex-row justify-center items-center py-4 mt-4 ${!isLoading && "animate__animated animate__backInLeft"
                  }`}
              >
                <p className="font-medium text-white text-sm">
                  توجد مشكله في تحميل المرفقات حاول مره اخرى !
                </p>
              </div>
            </>
          ) : (
            <div
              className={`w-full flex flex-col justify-center items-center border-none mr-8 ml-2 ${!isLoading &&
                property.nhcIntegration.attachFiles.length > 0 &&
                "animate__animated animate__backInLeft"
                }`}
            >
              {!isLoading && !isLoadingFiles && (
                <h2 className="w-full mr-2 text-base text-redColor">
                  في حالة وجود مشكله في المرفقات الرجاء الضغط هنا:{" "}
                  <IonIcon
                    className="text-xl text-primaryColor100 cursor-pointer"
                    icon={reloadOutline}
                    onClick={async () => await fetchFiles(true)}
                  />
                </h2>
              )}
              <div className="w-full overflow-x-auto mt-2">
                <div className="flex space-x-3">
                  <div className="relative flex-shrink-0">
                    <LightGalleryComponent
                      items={files.map((item, index): MediaItem => ({
                        file: item.file || "",
                        isImage: item.isImage,
                        thumbnail: item.thumbnail,
                        name: property.nhcIntegration.attachFiles[index]?.name
                      }))}
                      onError={async () => retryCount < 3 && await fetchFiles()}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="w-full flex flex-col justify-start items-center px-8 pb-8">
            <div
              className={`col-span-1 py-4 w-full flex flex-row justify-start items-center mt-2 ${!isLoading && "animate__animated animate__jello"
                }`}
            >
              <p className=" text-primaryColor100 text-2xl">
                تفاصيل الاعلان لدى الهيئة العامة للعقار
              </p>
            </div>

            {/* <div
              className={`grid grid-cols-2 gap-6 my-4 w-full ${!isLoading && "animate__animated animate__fadeInRightBig"
                }`}
            >
              {property.aNhcIntegrationResultDTO.body.result.advertisement
                .propertyType && (
                  <div className="flex flex-col items-center justify-center text-center min-h-[100px]">
                    <IonIcon icon={propertyTypeSvg} className="text-5xl mb-2" />
                    <div className="text-2xl text-[#262626]">
                      {
                        property.aNhcIntegrationResultDTO.body.result
                          .advertisement.propertyType
                      }
                    </div>
                    <div className="text-xl text-[#737373]">نوع العقار</div>
                  </div>
                )}

              {property.aNhcIntegrationResultDTO.body.result.advertisement
                .propertyAge && (
                  <div className="flex flex-col items-center justify-center text-center min-h-[100px]">
                    <IonIcon icon={propertyAgeSvg} className="text-5xl mb-2" />
                    <div className="text-2xl text-[#262626]">
                      {
                        property.aNhcIntegrationResultDTO.body.result
                          .advertisement.propertyAge
                      }
                    </div>
                    <div className="text-xl text-[#737373]">عمر العقار</div>
                  </div>
                )}

              {property.aNhcIntegrationResultDTO.body.result.advertisement
                .numberOfRooms && (
                  <div className="flex flex-col items-center justify-center text-center min-h-[100px]">
                    <IonIcon icon={guestRoomSvg} className="text-5xl mb-2" />
                    <div className="text-2xl text-[#262626]">
                      {
                        property.aNhcIntegrationResultDTO.body.result
                          .advertisement.numberOfRooms
                      }
                    </div>
                    <div className="text-xl text-[#737373]">الغرف</div>
                  </div>
                )}

              {property.aNhcIntegrationResultDTO.body.result.advertisement
                .propertyArea && (
                  <div className="flex flex-col items-center justify-center text-center min-h-[100px]">
                    <IonIcon
                      icon={buildingMeasurementSvg}
                      className="text-5xl mb-2"
                    />
                    <div className="text-2xl text-[#262626]">
                      {
                        property.aNhcIntegrationResultDTO.body.result
                          .advertisement.propertyArea
                      }{" "}
                      <span className="text-xl text-[#737373]">متر مربع</span>
                    </div>
                    <div className="text-xl text-[#737373]">مساحة العقار</div>
                  </div>
                )}

              {property.aNhcIntegrationResultDTO.body.result.advertisement
                .propertyUtilities[0] && (
                  <div className="flex flex-col items-center justify-center text-center min-h-[100px]">
                    <IonIcon
                      icon={propertyServicesSvg}
                      className="text-5xl mb-2"
                    />
                    <div className="text-2xl text-[#262626] mr-2 w-60">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUtilities
                        .map((item: any) => item)
                        .join(" | ")}
                    </div>
                    <div className="text-xl text-[#737373]">خدمات العقار</div>
                  </div>
                )}
            </div> */}

            <div className="w-full my-4 bg-yellow-100 border-r-4 border-yellow-500 text-yellow-700 p-2 rounded shadow-sm flex flex-row items-center gap-2" dir="rtl">
              <IonIcon icon={warning} className="text-xl text-yellow-600" />
              <p className="font-bold text-sm">
                نأمل مطابقة الموقع أدناه مع الموقع المذكور في وصف موقع العقار
                المذكور
              </p>
            </div>

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${!isLoading && "animate__animated animate__fadeInUpBig"
                  }`}
              >
                <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                  وصف موقع العقار حسب الصك
                </h2>
                <div
                  id="landAddress"
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${
                    isExpanded.location
                      ? "max-h-screen opacity-100"
                      : "max-h-24 overflow-hidden opacity-50 "
                  }`}
                >
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <p className="text-primaryColor100 text-xl">المنطقة :</p>
                    <p className="text-black text-xl mr-2">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.location.region ?? NOT_AVAILABLE}
                    </p>
                  </div>
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <p className="text-primaryColor100 text-xl">المدينة :</p>
                    <p className="text-black text-xl mr-2">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.location.city ?? NOT_AVAILABLE}
                    </p>
                  </div>
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <p className="text-primaryColor100 text-xl">الحي :</p>
                    <p className="text-black text-xl mr-2">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.location.district ?? NOT_AVAILABLE}
                    </p>
                  </div>
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <p className="text-primaryColor100 text-xl">رقم المخطط :</p>
                    <p className="text-black text-xl mr-2">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.planNumber ?? NOT_AVAILABLE}
                    </p>
                  </div>
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <p className="text-primaryColor100 text-xl">رقم القطعة :</p>
                    <p className="text-black text-xl mr-2">
                      {property.aNhcIntegrationResultDTO.body.result.advertisement.landNumber ?? NOT_AVAILABLE}
                    </p>
                  </div>
                </div>
                <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                  <button
                    onClick={() =>
                      setIsExpanded((prevState) => ({
                        ...prevState,
                        location: !prevState.location,
                      }))
                    }
                  >
                    {isExpanded.location
                      ? "إظهار أقل"
                      : "عرض البيانات كاملة"}
                  </button>
                </div>
              </div>

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${
                  !isLoading && "animate__animated animate__fadeInUpBig"
                }`}
              >
                <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                  معلومات العقار الأساسية
                </h2>
                <div
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${
                    isExpanded.basicPropInformation
                      ? "max-h-screen opacity-100"
                      : "max-h-24 overflow-hidden opacity-50 "
                  }`}
                >
                  {property.aNhcIntegrationResultDTO.body.result.advertisement
                    .advertisementType ? (
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          غرض الاعلان :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.advertisementType
                          }
                        </p>
                      </div>
                    </div>
                  ) : null}

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          استخدام العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUsages &&
                            property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUsages.length > 0
                            ? property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUsages.join(
                              " | "
                            )
                          : NOT_AVAILABLE}
                      </p>
                    </div>
                  </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          نوع العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.propertyType ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          عمر العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.propertyAge ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          مساحة العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.propertyArea ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          واجهة العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.propertyFace ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          عرض الشارع :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.streetWidth ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                  {property.aNhcIntegrationResultDTO.body.result.advertisement
                    .location.street ? (
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          اسم الشارع :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.location.street
                          }
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                  <button
                    onClick={() =>
                      setIsExpanded((prevState) => ({
                        ...prevState,
                        basicPropInformation: !prevState.basicPropInformation,
                      }))
                    }
                  >
                    {isExpanded.basicPropInformation
                      ? "إظهار أقل"
                      : "عرض البيانات كاملة"}
                  </button>
                </div>
              </div>

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${
                  !isLoading && "animate__animated animate__fadeInUpBig"
                }`}
              >
                <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                  تفاصيل العقار الداخلية
                </h2>
                <div
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out max-h-screen opacity-100`}
                >
                    <div className="w-full flex flex-row justify-between items-center p-2 border-none">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          عدد الغرف :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.numberOfRooms ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl whitespace-nowrap	">
                          خدمات العقار :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUtilities &&
                        property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUtilities.length > 0
                          ? property.aNhcIntegrationResultDTO.body.result.advertisement.propertyUtilities.join(
                              " | "
                            )
                          : NOT_AVAILABLE}
                        </p>
                      </div>
                    </div>
                </div>
              </div>

            <div
              className={`w-full my-4 p-4 border rounded shadow-lg ${!isLoading && "animate__animated animate__fadeInUpBig"
                }`}
            >
              <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                حالة العقار القانونية
              </h2>
              <div
                className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${isExpanded.propLegalStatus
                    ? "max-h-screen opacity-100"
                    : "max-h-24 overflow-hidden opacity-50 "
                  }`}
              >
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <div>
                      <p className=" text-primaryColor100 text-xl">
                        الالتزامات الأخرى علي العقار :
                      </p>
                    </div>
                    <div>
                      <p
                        className=" text-black text-xl mr-2"
                        style={{ textAlign: "justify" }}
                      >
                        {
                          property.aNhcIntegrationResultDTO.body.result
                            .advertisement.obligationsOnTheProperty ?? NOT_AVAILABLE
                        }
                      </p>
                    </div>
                  </div>

                <div className="w-full flex flex-row justify-between items-center p-2">
                  <div>
                    <p className=" text-primaryColor100 text-xl">وجود رهن؟ :</p>
                  </div>
                  <div>
                    <p
                      className=" text-black text-xl mr-2"
                      style={{ textAlign: "justify" }}
                    >
                      {property.aNhcIntegrationResultDTO.body.result
                        .advertisement.isPawned
                        ? "يوجد رهن"
                        : "لا يوجد رهن"}
                    </p>
                  </div>
                </div>

                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <div>
                      <p className=" text-primaryColor100 text-xl">
                        الضمانات ومدتها :
                      </p>
                    </div>
                    <div>
                      <p
                        className=" text-black text-xl mr-2"
                        style={{ textAlign: "justify" }}
                      >
                        {
                          (property?.aNhcIntegrationResultDTO?.body?.result?.advertisement?.guaranteesAndTheirDuration ?? "")
                          .trim() || NOT_AVAILABLE
                        }
                      </p>
                    </div>
                  </div>

                <div className="w-full flex flex-row justify-between items-center p-2">
                  <div>
                    <p className=" text-primaryColor100 text-xl">
                      وجود قيد ؟ :
                    </p>
                  </div>
                  <div>
                    <p
                      className=" text-black text-xl mr-2"
                      style={{ textAlign: "justify" }}
                    >
                      {property.aNhcIntegrationResultDTO.body.result
                        .advertisement.isConstrained
                        ? "يوجد قيد"
                        : "لا يوجد قيد"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                <button
                  onClick={() =>
                    setIsExpanded((prevState) => ({
                      ...prevState,
                      propLegalStatus: !prevState.propLegalStatus,
                    }))
                  }
                >
                  {isExpanded.propLegalStatus
                    ? "إظهار أقل"
                    : "عرض البيانات كاملة"}
                </button>
              </div>
            </div>

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${
                  !isLoading && "animate__animated animate__fadeInUpBig"
                }`}
              >
                <h2 className="text-2xl text-tan font-bold mb-2 text-center">
                  القيمة المالية للعقار
                </h2>

                <div
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out max-h-screen opacity-100`}
                >
                  <div className="w-full flex flex-row justify-between items-center p-2">
                    <div>
                      <p className="text-tan text-xl">سعر الوحدة/المتر الارض :</p>
                    </div>
                    <div className="flex items-center">
                      <p className="text-tan text-xl mr-2" style={{ textAlign: "justify" }}>
                        {NumberWithCommas(
                          property?.nhcIntegration?.customePrice
                        ) ??
                        NumberWithCommas(
                          property?.aNhcIntegrationResultDTO?.body?.result?.advertisement?.propertyPrice
                        ) ??
                        {NOT_AVAILABLE}}
                      </p>
                      <span className="flex items-center text-tan mr-2">
                        <SarIcon />
                      </span>
                    </div>
                  </div>
                </div>

              </div>

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${
                  !isLoading && "animate__animated animate__fadeInUpBig"
                }`}
              >
                <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                  معلومات المعلن
                </h2>

                <div
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${
                    isExpanded.AdvertiserInformation
                      ? "max-h-screen opacity-100"
                      : !isExpanded.AdvertiserInformation ||
                        property.nhcIntegration.user.officePhoneNumber ||
                        property.nhcIntegration.user.phoneNumber
                      ? "max-h-28 overflow-hidden opacity-75 "
                      : "max-h-28 overflow-hidden opacity-50 "
                  }`}
                >
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl whitespace-nowrap">
                          {" "}
                          اسم مسؤول الإعلان :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.advertiserName ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                  {/* رقم التواصل من الإعلان */}
                    <div className="w-full flex flex-col justify-center items-center p-2">
                      <div className="w-full flex flex-row justify-between items-center">
                        <p className="text-primaryColor100 text-xl">رقم جوال مسؤول الإعلان :</p>

                        <p className="text-primaryColor100 text-3xl mr-2" style={{ textAlign: "justify" }}>
                          {property.aNhcIntegrationResultDTO.body.result.advertisement.phoneNumber ? (
                            <a
                              href={`tel:${property.aNhcIntegrationResultDTO.body.result.advertisement.phoneNumber}`}
                              style={{ textDecorationLine: "underline" }}
                            >
                              <IonIcon icon={callOutline} />
                            </a>
                          ) : NOT_AVAILABLE}
                        </p>
                      </div>
                    </div>

                    {/* رقم المكتب */}
                    {property.nhcIntegration.user.officePhoneNumber && (
                      <div className="w-full flex flex-col justify-center items-center p-2">
                        <div className="w-full flex flex-row justify-between items-center">
                          <p className="text-primaryColor100 text-xl">رقم المكتب :</p>

                          <p className="text-primaryColor100 text-3xl mr-2" style={{ textAlign: "justify" }}>
                            <a
                              href={`tel:+966${property.nhcIntegration.user.officePhoneNumber}`}
                              style={{ textDecorationLine: "underline" }}
                            >
                              <IonIcon icon={callOutline} />
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                  {/* رقم الجوال */}
                  {property.nhcIntegration.user.phoneNumber && (
                    <div className="w-full flex flex-col justify-center items-center p-2">
                      <div className="w-full flex flex-row justify-between items-center">
                        <p className="text-primaryColor100 text-xl">رقم الجوال المسجل بمنصة ذكى :</p>

                          <p className="text-primaryColor100 text-3xl mr-2" style={{ textAlign: "justify" }}>
                            <a
                              href={`tel:+966${property.nhcIntegration.user.phoneNumber}`}
                              style={{ textDecorationLine: "underline" }}
                            >
                              <IonIcon icon={callOutline} />
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          رقم ترخيص الاعلان :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.adLicenseNumber ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                  {property.aNhcIntegrationResultDTO.body.result.advertisement
                    .brokerageAndMarketingLicenseNumber && (
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          رقم رخصة الوساطة والتسويق العقاري :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.brokerageAndMarketingLicenseNumber
                          }
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                  <button
                    onClick={() =>
                      setIsExpanded((prevState) => ({
                        ...prevState,
                        AdvertiserInformation: !prevState.AdvertiserInformation,
                      }))
                    }
                  >
                    {isExpanded.AdvertiserInformation
                      ? "إظهار أقل"
                      : "عرض البيانات كاملة"}
                  </button>
                </div>
              </div>

            {(property.aNhcIntegrationResultDTO.body.result.advertisement
              .deedNumber ||
              property.aNhcIntegrationResultDTO.body.result.advertisement
                .location.buildingNumber ||
              property.aNhcIntegrationResultDTO.body.result.advertisement
                .location.postalCode ||
              property.aNhcIntegrationResultDTO.body.result.advertisement
                .location.additionalNumber) && (
                <div
                  className={`w-full my-4 p-4 border rounded shadow-lg ${!isLoading && "animate__animated animate__fadeInUpBig"
                    }`}
                >
                  <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                    معلومات الموقع والتوثيق
                  </h2>
                  <div
                    className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${isExpanded.location_DocInfo
                        ? "max-h-screen opacity-100"
                        : "max-h-24 overflow-hidden opacity-50 "
                      }`}
                  >
                    {property.aNhcIntegrationResultDTO.body.result.advertisement
                      .deedNumber ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            رقم صك الملكية :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-black text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {
                              property.aNhcIntegrationResultDTO.body.result
                                .advertisement.deedNumber
                            }
                          </p>
                        </div>
                      </div>
                    ) : null}

                    {property.aNhcIntegrationResultDTO.body.result.advertisement
                      .location.buildingNumber ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            رقم المبني :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-black text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {
                              property.aNhcIntegrationResultDTO.body.result
                                .advertisement.location.buildingNumber
                            }
                          </p>
                        </div>
                      </div>
                    ) : null}

                    {property.aNhcIntegrationResultDTO.body.result.advertisement
                      .location.postalCode ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            الرمز البريدي :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-black text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {
                              property.aNhcIntegrationResultDTO.body.result
                                .advertisement.location.postalCode
                            }
                          </p>
                        </div>
                      </div>
                    ) : null}

                    {property.aNhcIntegrationResultDTO.body.result.advertisement
                      .location.additionalNumber ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            الرقم الإضافي :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-black text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {
                              property.aNhcIntegrationResultDTO.body.result
                                .advertisement.location.additionalNumber
                            }
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                    <button
                      onClick={() =>
                        setIsExpanded((prevState) => ({
                          ...prevState,
                          location_DocInfo: !prevState.location_DocInfo,
                        }))
                      }
                    >
                      {isExpanded.location_DocInfo
                        ? "إظهار أقل"
                        : "عرض البيانات كاملة"}
                    </button>
                  </div>
                </div>
              )}

              <div
                className={`w-full my-4 p-4 border rounded shadow-lg ${
                  !isLoading && "animate__animated animate__fadeInUpBig"
                }`}
              >
                <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                  تواريخ وترخيص الإعلان
                </h2>
                <div
                  className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out ${
                    isExpanded.AdvertisementDates_Licensing
                      ? "max-h-screen opacity-100"
                      : "max-h-24 overflow-hidden opacity-50 "
                  }`}
                >
                  {property.aNhcIntegrationResultDTO.body.result.advertisement
                    .creationDate ? (
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          تاريخ إنشاء ترخيص الاعلان :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.creationDate
                          }
                        </p>
                      </div>
                    </div>
                  ) : null}

                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div>
                        <p className=" text-primaryColor100 text-xl">
                          تاريخ انتهاء رخصة الإعلان :
                        </p>
                      </div>
                      <div>
                        <p
                          className=" text-black text-xl mr-2"
                          style={{ textAlign: "justify" }}
                        >
                          {
                            property.aNhcIntegrationResultDTO.body.result
                              .advertisement.endDate ?? NOT_AVAILABLE
                          }
                        </p>
                      </div>
                    </div>

                  {property.aNhcIntegrationResultDTO.body.result.advertisement
                    .qrCodeUrl ? (
                    <div className="w-full flex flex-row justify-between items-center p-2">
                      <div className="w-full flex flex-row justify-between items-center">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            رابط رمز الإستجابة السريع :
                          </p>
                        </div>
                        <div>
                          <p
                            className="text-xl mr-2 text-primaryColor100"
                            style={{ textAlign: "justify" }}
                          >
                            <a
                              target="_blank"
                              href={`${property.aNhcIntegrationResultDTO.body.result.advertisement.qrCodeUrl}`}
                              style={{ textDecorationLine: "underline" }}
                            >
                              <IonIcon icon={linkOutline} />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="mt-2 text-primaryColor100 font-bold text-center bg-[#f8f8f8]">
                  <button
                    onClick={() =>
                      setIsExpanded((prevState) => ({
                        ...prevState,
                        AdvertisementDates_Licensing:
                          !prevState.AdvertisementDates_Licensing,
                      }))
                    }
                  >
                    {isExpanded.AdvertisementDates_Licensing
                      ? "إظهار أقل"
                      : "عرض البيانات كاملة"}
                  </button>
                </div>
              </div>

            {(property.aNhcIntegrationResultDTO.body.result.advertisement
              .complianceWithTheSaudiBuildingCode ||
              property.nhcIntegration.ad_Views) && (
                <div
                  className={`w-full my-4 p-4 border rounded shadow-lg ${!isLoading && "animate__animated animate__fadeInUpBig"
                    }`}
                >
                  <h2 className="text-xl text-primaryColor100 font-bold mb-2 text-center">
                    معلومات إضافية
                  </h2>
                  <div
                    className={`w-full flex border rounded-lg flex-col divide-y transition-all duration-300 ease-in-out opacity-100`}
                  >
                    {property.aNhcIntegrationResultDTO.body.result.advertisement
                      .complianceWithTheSaudiBuildingCode ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl">
                            مطابقة كود البناء السعودي :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-black text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {property.aNhcIntegrationResultDTO.body.result
                              .advertisement.complianceWithTheSaudiBuildingCode
                              ? "مطابق"
                              : "غير مطابق"}
                          </p>
                        </div>
                      </div>
                    ) : null}

                    {property.nhcIntegration.description ? (
                      <div className="w-full flex flex-col p-2">
                        {/* Label on top of description */}
                        <div className="mb-2">
                          <p className="text-primaryColor100 text-xl">
                            الوصف:
                          </p>
                        </div>

                        {/* Description */}
                        <div className="border-2 border-primaryColor100 rounded-xl p-4 shadow-md bg-white">
                          <p
                            className="text-black text-xl mr-2"
                            style={{
                              textAlign: "justify",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {property.nhcIntegration.description}
                          </p>
                        </div>
                      </div>
                    ) : null}


                    {property.nhcIntegration.ad_Views ? (
                      <div className="w-full flex flex-row justify-between items-center p-2">
                        <div>
                          <p className=" text-primaryColor100 text-xl ">
                            عدد المشاهدات :
                          </p>
                        </div>
                        <div>
                          <p
                            className=" text-primaryColor100 text-xl mr-2"
                            style={{ textAlign: "justify" }}
                          >
                            {property.nhcIntegration.ad_Views}{" "}
                            <IonIcon
                              icon={eye}
                              style={{ marginBottom: "-4px" }}
                            />
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}

            {property.aNhcIntegrationResultDTO.body.result.advertisement
              .qrCodeUrl && (
                <div
                  style={{
                    height: "auto",
                    margin: "0px 0px 0px 35px",
                    maxWidth: 64,
                    width: "100%",
                  }}
                  className={`border-none ${!isLoading && "animate__animated animate__fadeInDownBig"
                    }`}
                >
                  <QRCode
                    size={256}
                    className="pt-5"
                    style={{ height: "auto", maxWidth: "150%", width: "150%" }}
                    value={
                      property.aNhcIntegrationResultDTO.body.result.advertisement
                        .qrCodeUrl
                    }
                    viewBox={`0 0 256 256`}
                  />
                </div>
              )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

const ModalImagesExample = ({
  image,
  onCloseImageDismiss,
}: ModalImagesProps) => {
  return (
    <IonContent>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="text-primaryColor100 text-xl">
            عرض الصورة
          </IonTitle>
          <IonButtons slot="end">
            <Button
              size={"small"}
              text="اغلاق"
              theme={"danger"}
              onClick={() => onCloseImageDismiss(null, "cancel")}
            ></Button>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <img src={image} className="w-full rounded" />
      </IonContent>
    </IonContent>
  );
};

const ModalVideoExample = ({
  video,
  onCloseVideoDismiss,
}: ModalVideoProps) => {
  return (
    <IonContent>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="text-primaryColor100 text-xl">
            عرض الفيديو
          </IonTitle>
          <IonButtons slot="end">
            <Button
              size={"small"}
              text="اغلاق"
              theme={"danger"}
              onClick={() => onCloseVideoDismiss(null, "cancel")}
            ></Button>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <video autoPlay controls src={video} className="w-full rounded"></video>
      </IonContent>
    </IonContent>
  );
};

export default NhcAdvertisement;
